import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer'
import { Vector2 } from 'three'
import { KVPrimitive, RolodexEntryPatchJson } from 'types'

import { KVMessageDef } from './index'

export function getNewPrimitiveMessage() {
  return {
    type: 'newPrimitive',
    requiredData: ['primitiveId'],

    callback: (
      json: Record<string, unknown>,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      const primitive = KVPrimitive.fromJSON(json)

      // Determine if this primitive already exists
      const existingIndex = kv.primitives?.findIndex(
        (p) => p.id === primitive.id
      )

      if (kv.primitives) {
        let newPrimitives = [...kv.primitives]
        const isNewPrimitive =
          existingIndex === undefined || existingIndex === -1

        // If there is already a primitive with the same id, update it
        if (!isNewPrimitive) {
          const existing = kv.primitives[existingIndex]
          // Preserve original creator info and tags
          primitive.tags = existing.tags
          primitive.userName = existing.userName
          primitive.userEmail = existing.userEmail
          primitive.createdAt = existing.createdAt
          newPrimitives[existingIndex] = primitive
        } else {
          // Set user metadata for new primitives
          primitive.userName = kv.user?.name ?? ''
          primitive.userEmail = kv.user?.email ?? ''
          // createdAt set in constructor
          // Apply whiteboard tag immediately if in SystemView context (for new primitives only)
          if (kv.selectedWhiteboardId) {
            primitive.tags = {
              ...primitive.tags,
              whiteboard: {
                derivedTag: false,
                value: kv.selectedWhiteboardId,
              },
            }
          }
          // Only add if it's truly new
          newPrimitives = [...kv.primitives, primitive]
        }

        kv.setPrimitives(newPrimitives)

        // Position popup menu (similar to annotations)
        const kvElementRect = kv.videoParent.current?.getBoundingClientRect()
        if (kvElementRect) {
          const topRightX = kvElementRect.width - 475
          const topRightY = 20
          kv.setPopupMenuStartPosition(new Vector2(topRightX, topRightY))
        }
        kv.setSelectedMarkup(primitive)

        // Track primitive in rolodex
        const patchData: RolodexEntryPatchJson = {
          id: kv.kestrelModel?.id ?? '',
          data: {
            primitives: newPrimitives.map((p) => KVPrimitive.toJSON(p)),
          },
        }
        kv.rolodexPatch([patchData])
      }
    },
  } as KVMessageDef
}
